module.exports = __webpack_public_path__ + "img/icon-select-gray.503f84d2.svg";